









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
})
export default class SiteBreadcrumb extends Vue {
  @Prop({ type: Array })
  breadcrumbs!: Array<Breadcrumb>
}
